import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Translate } from '../../../../shared/LanguageService';

type NoAvailablePhotographersLabels = {
    noPhotographers: string;
};

type ExternalProps = {
    isAdvancedMode: boolean;
};

type NoAvailablePhotographersProps = {
    labels: NoAvailablePhotographersLabels;
} & ExternalProps;

function NoAvailablePhotographers({ isAdvancedMode, labels }: NoAvailablePhotographersProps) {
    return (
        <Box
            sx={{
                width: '100%',
                marginTop: !isAdvancedMode ? '' : '16px',
                height: !isAdvancedMode ? 'calc(77vh - 85px)' : 'calc(77vh - 155px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid #E0E0E0',
                borderRadius: '5px'
            }}
        >
            <Typography>{labels.noPhotographers}</Typography>
        </Box>
    );
}

const NoAvailablePhotographersTranslationLayer = (props: ExternalProps) => {
    let labels: NoAvailablePhotographersLabels = {
        noPhotographers: Translate('orders/list/bookings-calendar/no-photographers')
    };

    return <NoAvailablePhotographers {...props} labels={labels} />;
};

export default NoAvailablePhotographersTranslationLayer;
